module.exports = __webpack_public_path__ + "static/media/TableScratch3_After.666f7905.jpg";